export const parseAnswerModelSettings = (llm) => {
  try {
    const settings = JSON.parse(llm);
    if (!settings || typeof settings.model !== 'string' || !settings.model.trim()
      || typeof settings.isThink !== 'boolean'
      || (settings.temperature !== null && (typeof settings.temperature !== 'number' || !Number.isFinite(settings.temperature)))
      || typeof settings.reasoningEffort !== 'string') return null;
    return {
      model: settings.model,
      isThink: settings.isThink,
      temperature: settings.temperature,
      reasoningEffort: settings.reasoningEffort
    };
  } catch {
    return null;
  }
};
